// extracted by mini-css-extract-plugin
module.exports = {"link":"Documents_link__3URzA","fadeIn":"Documents_fadeIn__12wFw","fadeOut":"Documents_fadeOut__2jd_Q"};